export default __webpack_public_path__ + "images/60dbd52dccd8b70b8877eee42d2b88dd-aderant-logo.svg";